import GroupedQuestionsTabNav from '../GroupedQuestionsTabNav';
import { QuestionSetNavBar } from '../QuestionSetNavBar';
import { QuestionWrapper } from '../Question';
import IPT from 'react-immutable-proptypes';
import PT from 'prop-types';
import { Container } from 'edrolo-style-guide';

/*
 * This is part of the core Question Set experience.
 * Please be aware that there are two contexts to consider when working on this component:
 *    The main application experience that is rendered in `edrolo/domains/exams/components/QuestionSetPage`
 *    The demo experience that is rendered in `edrolo/domains/exams/components/QuestionSetPageDemo`
 *
 * Anything that happens in here down in the tree needs to be considered for
 * both authenticated and unauthenticated views.
 */

const QuestionSet = ({
  classId,
  examId,
  questionId,
  sittingId,
  exam,
  question,
  response,
  isTeacher,
  prevNextIds,
  rootQuestionDescendants,
  submitQuestionResponse,
  submitChecklistReflectionItem,
  submitGrok,
  submitMark,
  buildQuestionSetUrl,
  searchParams,
  push,
}) => {
  const handleQuestionComplete = () => {
    // will return index when nextQuestionWhenSaved is undefined/null
    const url = buildQuestionSetUrl(examId, prevNextIds.nextId, classId);

    push(url);
  };

  return (
    <Container wide>
      <QuestionSetNavBar
        previousQuestionUrl={buildQuestionSetUrl(
          examId,
          prevNextIds.prevParentId,
          classId
        )}
        nextQuestionUrl={buildQuestionSetUrl(
          examId,
          prevNextIds.nextParentId,
          classId
        )}
        questionSetIndexUrl={buildQuestionSetUrl(examId, null, classId)}
        searchParams={searchParams}
        courseId={exam.get('course')}
      />

      <GroupedQuestionsTabNav
        classId={classId}
        examId={examId}
        rootQuestionDescendants={rootQuestionDescendants}
        buildQuestionSetUrl={buildQuestionSetUrl}
      />

      <QuestionWrapper
        classId={classId}
        exam={exam}
        question={question}
        response={response}
        isTeacher={isTeacher}
        onSubmit={(typeSpecificData) => {
          submitQuestionResponse(
            examId,
            questionId,
            sittingId,
            typeSpecificData
          );
        }}
        onSubmitChecklistReflectionItem={(checklistReflectionItem) => {
          submitChecklistReflectionItem(
            questionId,
            sittingId,
            checklistReflectionItem
          );
        }}
        onSubmitGrok={(grok) => {
          submitGrok(examId, questionId, sittingId, grok);
        }}
        onSubmitMark={(mark) => {
          submitMark(questionId, sittingId, mark);
        }}
        onQuestionComplete={() => {
          handleQuestionComplete();
        }}
        isLastQuestion={!prevNextIds.nextId}
      />
    </Container>
  );
};

QuestionSet.propTypes = {
  exam: IPT.map.isRequired,
  examId: PT.string.isRequired,
  classId: PT.oneOfType([PT.string, PT.number]).isRequired,
  questionId: PT.string.isRequired,
  sittingId: PT.number,
  isTeacher: PT.bool.isRequired,
  buildQuestionSetUrl: PT.func.isRequired,
  question: PT.object.isRequired,
  submitQuestionResponse: PT.func.isRequired,
  submitChecklistReflectionItem: PT.func.isRequired,
  submitGrok: PT.func.isRequired,
  submitMark: PT.func.isRequired,
  response: PT.any,
  rootQuestionDescendants: PT.any.isRequired,
  prevNextIds: PT.shape({
    prevParentId: PT.number,
    nextParentId: PT.number,
    prevId: PT.number,
    nextId: PT.number,
  }).isRequired,
  searchParams: PT.object.isRequired,
  push: PT.func.isRequired,
};

export default QuestionSet;
